export default "__VITE_ASSET__DgjnEEJr__"